/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */
// @ts-nocheck
import * as React from 'react';
import {Helmet} from 'react-helmet-async';
import {BrowserRouter, useRoutes} from 'react-router-dom';
import {routes} from './routes';

import {GlobalStyle} from 'styles/global-styles';
import "styles/background.scss";
import "styles/animations.scss";
import "animate.css";

import {useTranslation} from 'react-i18next';
import {Toaster} from 'react-hot-toast';

import {ThemeProvider} from '@mui/material/styles';
import {theme} from "../styles/theme";


function RoutesComponent() {
    const routesElement = useRoutes(routes);
    return <>{routesElement}</>;
}

export function App() {
  const { i18n } = useTranslation();


  return (
    <ThemeProvider theme={theme}>
        <BrowserRouter>
            <Helmet
                titleTemplate="%s - Controlla Voice"
                defaultTitle="Controlla Voice"
                htmlAttributes={{lang: i18n.language}}
            >
                <meta name="Controlla Voice" content="Generate and transform vocals using AI"/>
            </Helmet>
            <div><Toaster position="bottom-center" toastOptions={{
                style: {
                    fontSize: '20px',
                },
                success: {
                    style: {
                        color: '#0C0810',
                    },
                },
                error: {
                    style: {
                        color: '#0C0810',
                    },
                },
            }}/></div>
            <RoutesComponent />
            <GlobalStyle/>
        </BrowserRouter>
    </ThemeProvider>
  );
}
